import * as React from 'react';
import DefaultIcon from './DefaultIcon';
export default (props) => (React.createElement(DefaultIcon, Object.assign({}, props, { viewBox: "0 96 960 960" }),
    React.createElement("path", { d: "M200 296v-80h560v80H200Zm280 640q-117 0-198.5-81.5T200 656q0-117 81.5-198.5T480 376q117 0 198.5 81.5T760 656q0 117-81.5 198.5T480 936Zm0-100q75 0 127.5-52.5T660 656q0-75-52.5-127.5T480 476q-75 0-127.5 52.5T300 656q0 75 52.5 127.5T480 836Z" })));
